export default "__VITE_ASSET__BVRnV7UI__"